<template>
  <div>
    <HomePC v-if="clientType == 'pc'" />
    <HomeMobile v-if="clientType == 'mobile'" />
  </div>
</template>

<script>
import { isPhone } from '@/utils/device.js'
import HomePC from './HomePC.vue'
import HomeMobile from './HomeMobile.vue'
import { mapState } from 'vuex';

export default {
  name: 'HomeView',
  components: {
    HomePC,
    HomeMobile
  },
  data() {
    return {
      clientType: isPhone() ? 'mobile' : 'pc'
    }
  }
}
</script>
<style lang="less" scoped></style>
